/* eslint-disable max-classes-per-file */
import { jsonParse } from "@/utils/common/jsonHelper/jsonHelper";

export interface RequestHotelPolicyBySlugInterface {
  countrySlug: string;
  citySlug: string;
  areaSlug: string;
  hotelSlug: string;
}

export interface RequestHotelPolicyInterface {
  hotelId: number;
}

export interface ResponseHotelPolicyInterface {
  status: boolean;
  isAgodaPolicy: boolean;
  data: DataHotelPolicy;
}

export interface DataHotelPolicyInterface {
  remark: string;
  childAndExtrabedPolicy: ChildAndExtrabedPolicy;
}

export interface ChildAndExtrabedPolicyInterface {
  infant: string;
  children: string;
  adult: string;
  childrenStayFree: boolean;
  minGuestAge: string;
}

export class ChildAndExtrabedPolicy {
  infant: string;

  children: string;

  adult: string;

  childrenStayFree: boolean;

  minGuestAge: string;

  constructor(res: ChildAndExtrabedPolicyInterface) {
    this.infant = res.infant || "";
    this.children = res.children || "";
    this.adult = res.adult || "";
    this.childrenStayFree = res.childrenStayFree || false;
    this.minGuestAge = res.minGuestAge || "";
  }
}

export class DataHotelPolicy {
  remark: string;

  childAndExtrabedPolicy: ChildAndExtrabedPolicy;

  constructor(res: DataHotelPolicyInterface) {
    this.remark = res.remark || "";
    this.childAndExtrabedPolicy = new ChildAndExtrabedPolicy(
      res.childAndExtrabedPolicy || {},
    );
  }
}

export class ResponseHotelPolicy {
  status: boolean;

  isAgodaPolicy: boolean;

  data: DataHotelPolicy;

  constructor(data: ResponseHotelPolicyInterface) {
    this.status = data.status || false;
    this.isAgodaPolicy = data.isAgodaPolicy || false;
    const parsedData = jsonParse(JSON.stringify(data.data));
    this.data = new DataHotelPolicy(parsedData || {});
  }
}
